// The base API Management URI
const baseUri = "https://apidev.hku.hk";

// The Microsoft Entra ID application registration client ID
const clientId = "6498d2ce-1f05-4193-929c-15c332996e37";

// The Microsoft Entra ID tenant ID
const tenantId = "e80d8e75-52b9-4839-a358-87abb93b3567";

// The scope for the access token request to call the Microsoft Graph API
const scope = "https://graph.microsoft.com/.default";

// Redirects the user to the login endpoint with the appropriate parameters to begin the authentication flow
const login = () => {
    window.location.href =
        `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?response_type=code&redirect_uri=${baseUri}/auth/callback&client_id=${clientId}&scope=${scope}`;
};

// Logs the user out of the application by redirecting to the logout endpoint of Microsoft Entra ID which will in turn call the logout endpoint of the application to remove the cookie
const logout = () => {
    window.location.href = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/logout?post_logout_redirect_uri=${baseUri}/auth/logout`;
};

// Calls the graph endpoint and displays the result
const callApi = async () => {
    // Display loading message
    document.getElementById("result").innerText = "Loading...";
    console.log(document.cookie);

    // Call the Graph API endpoint
    try {
        const response = await fetch("https://apidev.hku.hk/graph/me", {
            method: "GET",
            headers: {
                "Accept": "application/json"
            },
            credentials: "include"
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        document.getElementById("result").innerText = JSON.stringify(data, null, 2);
    } catch {
        console.log("An error occurred when calling graph/me.");
        document.getElementById("result").innerText = "An error occurred";
    }
};

const uploadFile = async () => {
    const fileInput = document.getElementById("file-input");
    const file = fileInput.files[0];
    if (!file) {
        alert("Please select a file to upload.");
        return;
    }

    try {
        const response = await fetch("https://apidev.hku.hk/graph/upload", {
            credentials: "include",
            method: "PUT", // Changed from POST to PUT
            headers: {
                "Content-Type": file.type,
            },
            body: file, // Directly use the file object as the body
        });

        if (response.ok) {
            const result = await response.json();
            document.getElementById("result").innerText = JSON.stringify(result, null, 2);
        } else {
            document.getElementById("result").innerText = "File upload failed.";
        }
    } catch (error) {
        console.error("Error:", error);
        document.getElementById("result").innerText = "An error occurred";
    }
};

// Exports the functions to be used in the HTML
export { login, logout, callApi, uploadFile };